"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const IInvoice_1 = require("../models/invoice/IInvoice");
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
class InvoiceCreateValidator extends GenericValidator_1.default {
    invoiceOptions = Object.values(IInvoice_1.IInvoicedBy);
    _invoiceCreateSchema = joi_1.default.object({
        ids: joi_1.default.array().items(joi_1.default.string()).min(1).required().unique(),
        invoiceOption: joi_1.default.string()
            .required()
            .valid(...this.invoiceOptions),
        ignoreChargeStatus: joi_1.default.boolean().optional(),
    });
    validate(input) {
        super.validate(input, 'IInvoiceCreate', this._invoiceCreateSchema);
    }
}
exports.default = InvoiceCreateValidator;
